import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/users")({
	component: UsersLayout,
})

function UsersLayout() {
	return <Outlet />
}
